/* istanbul ignore next */
// cleanup_convert_to_typescript_file_GENERICS

import { createUseStyles } from '@glu/theming';

const styles = ({
  badge,
  button = {},
  formElements = {},
  palette: { background, colors, common, error, form, primary, text } = {},
  spacing: { unit } = {},
  typography = {}
}) => ({
  gluOverride: {
    '& [data-qa="mobilegrid"]': {
      maxWidth: 'calc(100vw - 2rem)'
    },
    '& [class*="open"]': {
      zIndex: 2000
    },
    // TODO - CB-48476 - remove this after @glu/nav-react is upgraded (GLU-6168 is fixed in nav-react 3.4.3, so this is a duplicate fix which should be removed after the upgrade)
    '& [class*="openLogo"]': {
      display: 'flex',
      alignItems: 'center',
      '& svg, & img': {
        height: 'auto'
      }
    },
    fontSize: 16,
    '& [data-qa="date-select"] ': {
      // Add background to @glu/datepicker-react
      background: '#ffffff'
    },
    '& .visuallyHidden': {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    },
    fontFamily: typography.fontFamily,
    '& .glu-content, .glu-container, .container': {
      maxWidth: 'none'
    },
    '& .navbar': {
      borderRadius: 0
    },
    '& [class*="col-"]': {
      paddingLeft: unit * 2,
      paddingRight: unit * 2
    },
    '& .no-gutters': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '& h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6': {
      marginBottom: unit * 1.25
    },
    '& h4': {
      fontWeight: typography.fontWeightMedium
    },
    '& .badge': {
      ...badge
    },
    /** @description Grid Overrides, might want to put these somewhere else */
    '& .grid': {
      '& .navigate': {
        '& nav': {
          display: 'flex',
          alignItems: 'center',
          '& .flex-dropdown-wrapper': {
            display: 'flex !important', // important is reqd here, else will be overriden by component specific styles
            alignItems: 'center',
            paddingRight: unit / 2,
            '& label': {
              margin: 'auto',
              paddingRight: unit / 2
            }
          },
          '& span': {
            margin: 'auto'
          },
          '& .btn-tertiary': {
            marginLeft: unit / 2
          }
        }
      }
    },

    '& .shadow': {
      boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)'
    },

    '& .divider': {
      float: 'left',
      marginBottom: unit * 2,
      marginTop: unit * 2,
      width: '100%'
    },

    '& .no-label': {
      paddingTop: unit * 3.5
    },

    '& .radio-inline': {
      display: 'inline',
      lineHeight: 2,
      '& input': {
        boxShadow: 'none',
        bottom: 0
      }
    },

    '& .radio-inline-padded': {
      display: 'inline',
      paddingRight: '20px',
      '& input': {
        boxShadow: 'none'
      }
    },

    '& .optional label': {
      ...formElements.optionalLabel,
      display: 'inline-block',
      marginBottom: '5px',
      '& span': {
        fontWeight: 'normal',
        textTransform: 'capitalize',
        marginRight: '-10px'
      }
    },
    '& .optional label::after': {
      ...formElements.optionalAfter
    },
    '& .flex-dropdown-wrapper': {
      '& .flex-dropdown .selection': {
        borderRadius: 2
      }
    },
    '& .block-label .flex-dropdown-wrapper label': {
      display: 'block',
      lineHeight: '1.70em'
    },

    '& .block-label .flex-dropdown-wrapper .flex-dropdown': {
      width: '100%'
    },

    '& .form-group': {
      ...formElements.formGroup,
      '& .help-block, small': {
        color: text.midGray
      },
      '& .has-error': {
        '& small': {
          color: error.dark
        }
      }
    },
    '& .form-group.has-error': {
      '& .help-block': {
        color: error.dark
      }
    },

    '& .form-group label, .form-group .label': {
      ...formElements.label,
      marginBottom: '5px',
      '& [class*="optional-"], [class*="helpWrapper"] [data-component-name="glu-form-components--error"] p':
        {
          textTransform: 'none'
        }
    },
    '& .text-wrap-normal': {
      whiteSpace: 'normal'
    },

    '& .form-group input': {
      ...formElements.input
    },

    /*
     * @TODO: Update colors from pallette
     */
    '& .has-error .form-control': {
      border: `1px solid ${error.dark}`
    },

    // Outline flex dropdown box
    '& .has-error .flex-dropdown .selection': {
      borderColor: error.dark
    },
    '& .has-error label': {
      color: error.dark
    },

    '& .form-control': {
      ...formElements.formControl
    },

    '& .form-control:focus': {
      boxShadow: 'none'
    },

    '& .btn': {
      fontFamily: typography.fontFamily,
      fontSize: typography.fontSize,
      ...button,
      '&.btn-primary': {
        ...button.primary
      },
      '&.btn-secondary': {
        ...button.secondary
      },
      '&.btn-link, &.btn-tertiary': {
        ...button.tertiary,
        fontFamily: typography.headline2.fontFamily,
        backgroundColor: 'transparent',
        textDecoration: 'none'
      },
      '&.btn-center': {
        display: 'flex',
        alignItems: 'center'
      }
    },

    '& .btn-toggle': {
      '&:first-child': {
        borderRadius: `${button.borderRadius}px 0 0 ${button.borderRadius}px`
      },
      '&:last-child': {
        borderRadius: `0 ${button.borderRadius}px ${button.borderRadius}px 0`
      }
    },

    '& .table-padded': {
      '& th,td': {
        paddingRight: unit * 2
      }
    },

    '& button': {
      borderWidth: 1
    },
    '& [class*="switchMain"]': {
      '&:after': {
        backgroundColor: common.white
      }
    },
    '& [class*="dropdownHeader"]': {
      flexWrap: 'wrap'
    },
    // glu datepicker-react global styles
    '& [class*="datepicker"]': {
      '& label > p': {
        marginBottom: 5
      },
      // override the label element styles from glu.css
      '& [class*="calendar"] label': {
        display: 'inline'
      },
      '& [class^="iconWrapper"]': {
        top: 12
      },
      '& p[class*="day"]': {
        margin: 0
      },
      '& [data-qa="popup"]': {
        zIndex: 101
      },
      '& [class*="selected"]': {
        backgroundColor: primary.normal
      }
    },
    '& input[type="checkbox"]:checked + div svg': {
      fill: text.dark
    },
    '& [data-qa^="dropdown"] > label': {
      width: '100%'
    },
    '& .sr-only': {
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      clipPath: 'inset(50%)',
      border: 0
    },
    '& [data-qa="weekly"]': {
      '& button:focus': {
        border: '1px solid #5e9ed6'
      },
      '& button[class*="active"]:focus': {
        border: '1px solid #ff0000'
      }
    },
    '& [data-qa="receiverModal"]': {
      maxHeight: 'calc(100% - 80px)',
      maxWidth: '800px',
      overflowY: 'scroll'
    },
    // set fallback border color for dropdowns with badges when BFS branding Palette Form Border in unset
    '& div[data-component-name="glu-dropdown--dropdown"]': {
      '& input[class*="transparentInputValue-"]:not([class*="error-"])': {
        ...(form.border
          ? {}
          : {
              borderColor: common.black
            })
      }
    },
    // override tooltip background color
    '& div[data-component-name*="glu-tooltip--tooltip"]': {
      backgroundColor: common.white
    },
    '& [class*="filterableWrapper-"]': {
      // override tooltip background color for grid filters
      '& div[data-component-name*="glu-tooltip--tooltip"]': {
        backgroundColor: background
      },
      // override calendar icon alignment in grid filters
      '& [class*="datepicker"] [class^="iconWrapper"]': {
        top: 1.25 * unit
      }
    },
    '& [data-component-name="glu-list-builder--list-builder"]': {
      '& [class^="root-"]': {
        margin: 0
      },
      '& [class*="actionableIcon"]': {
        borderRadius: '50%'
      },
      '& [class*="actionableIcon"]:not(:hover, :focus)': {
        background: common.white
      },
      '& [class*="titleContainer"] button': {
        padding: 0,
        height: 2 * unit
      }
    },

    // override the styles of the prefix symbol of the glu input mask
    '& [data-component-name="glu-input-mask--input-mask"]': {
      '& [class*="symbol"]': {
        backgroundColor: background
      },
      '& [class*="symbolError"]': {
        borderColor: error.dark
      }
    },
    '& [data-component-name="glu-input-mask--input-mask"]:has(input:disabled)': {
      '& div[class*="symbol"]': {
        backgroundColor: '#ededed'
      }
    },
    '& [class*="switchWrapper-"]': {
      '& span': {
        color: typography.label.color
      }
    },
    '& [data-component-name="glu-modal--modal"]': {
      '& [class*="primaryHeader-"]': {
        marginBottom: 0
      }
    },
    '& [class*="scheduler-"]': {
      '& [class*="endSelected-"] > span': {
        paddingLeft: 3 * unit
      }
    },
    '& [data-component-name="glu-alerts--base-alert"]': {
      maxWidth: 'unset',
      width: '100%',
      '& [class*="alertDetails"]': {
        color: colors?.mineShaft || '#333333'
      },
      '& [data-component-name="glu-icons--x-icon"]': {
        fill: colors?.mineShaft || '#333333'
      },
      '& [class*="alertTitle"], & [class*="accordionHeaderContent"]': {
        fontWeight: 'normal'
      },
      '& [data-component-name="glu-accordion--accordion-panel-content"]': {
        color: colors?.mineShaft || '#333333'
      },
      '& [data-component-name="glu-accordion--accordion-panel-header"] [class*="accordionHeader"]':
        {
          color: colors?.mineShaft || '#333333',
          '& [data-component-name="glu-icons--icon-wrapper"] svg': {
            fill: colors?.mineShaft || '#333333'
          }
        }
    }
  }
});

export default createUseStyles(styles);
